import { defineStore } from "pinia";
import { UserState } from "@/stores/interface";
import { getCurrentAdminUserInfo } from "@/api/modules/auth/user";
import { piniaPersistConfig } from "@/config/piniaPersist";
// import { useRouter } from "vue-router"; // useRoute,
import router from "@/routers";
import { ElMessage } from "element-plus";
import { LOGIN_URL } from "@/config";
// import { useRenderDialog } from "@/hooks/useGetUserTelephone";
// import { number } from "echarts";

// const router = useRouter();
// const route = useRoute();

export type UserInfo = {
  [x: string]: any;
  name?: string;
  qy_wechat_auth_nickname?: string;
  telephone?: string;
  email?: string;
  nickname?: string;
  avatar?: string | any;
  is_active?: boolean;
  is_staff?: boolean;
  gender?: string;
  wx_server_openid?: null | number | string;
  is_wx_server_openid?: boolean;
  id?: null | number;
  update_datetime?: string;
  create_datetime?: string;
  is_reset_password?: boolean;
  last_login?: string;
  last_ip?: string;
  qy_user_id?: string | null;
  roles?: [];
  departments?: [];
  permissions?: [];
};
// avatar: "",
// nickname: "",
// name: ""
export const useUserStore = defineStore({
  id: "dev-user",
  state: (): UserState => ({
    token: "",
    tokenType: "",
    refreshToken: "",
    userInfo: {
      telephone: "",
      designerdata: {},
      qy_user_id: null,
      id: null,
      nickname: "",
      jobs: []
    },
    roles: [],
    permissions: []
  }),
  getters: {
    getUser(): UserInfo {
      return {
        name: (this.userInfo as UserInfo).name || "",
        qy_wechat_auth_nickname: (this.userInfo as UserInfo).qy_wechat_auth_nickname || "",
        telephone: (this.userInfo as UserInfo).telephone || "",
        email: (this.userInfo as UserInfo).email || "",
        nickname: (this.userInfo as UserInfo).nickname || "",
        avatar: (this.userInfo as UserInfo).avatar || "",
        is_active: (this.userInfo as UserInfo).is_active || false,
        is_staff: (this.userInfo as UserInfo).is_staff || false,
        gender: (this.userInfo as UserInfo).gender || "",
        wx_server_openid: (this.userInfo as UserInfo).id || null,
        is_wx_server_openid: (this.userInfo as UserInfo).is_wx_server_openid || false,
        id: (this.userInfo as UserInfo).id || null,
        update_datetime: (this.userInfo as UserInfo).update_datetime || "",
        create_datetime: (this.userInfo as UserInfo).create_datetime || "",
        is_reset_password: (this.userInfo as UserInfo).is_reset_password || true,
        last_login: (this.userInfo as UserInfo).last_login || "",
        last_ip: (this.userInfo as UserInfo).last_ip || "",
        roles: (this.userInfo as UserInfo).roles || [],
        departments: (this.userInfo as UserInfo).departments || [],
        permissions: (this.userInfo as UserInfo).permissions || [],
        qy_user_id: (this.userInfo as UserInfo).qy_user_id || ""
      };
    },
    getRoles(): string[] {
      return this.roles;
    },
    getPermissions(): string[] {
      return this.permissions;
    },
    getToken(): string {
      return this.token;
    },
    getAllToken(): string {
      // if (Object.keys(this.userInfo).length) return ""
      return `${this.tokenType} ${this.token}`;
    },
    getRefreshToken(): string {
      return this.refreshToken;
    },
    getTokenType(): string {
      return this.tokenType;
    }
  },
  actions: {
    // Set Token
    setToken(token: string) {
      //debugger;
      this.token = token;
    },
    // Set setUserInfo
    setUserInfo(userInfo: UserInfo) {
      this.userInfo = userInfo;
    },
    setRole(roles: []) {
      this.roles = roles;
    },
    setPermissions(permissions: []) {
      this.permissions = permissions;
    },
    setRefreshToken(refreshToken: string) {
      this.refreshToken = refreshToken;
    },
    setTokenType(tokenType: string) {
      this.tokenType = tokenType;
    },
    logout(message?: string, isRedirect?: boolean) {
      this.token = "";
      this.tokenType = "";
      this.refreshToken = "";
      this.userInfo = {};
      this.roles = [];
      this.permissions = [];
      if (!isRedirect) router.replace(LOGIN_URL);
      if (message) {
        ElMessage.error(message);
      }
    },
    // clearuserdata() {
    //   this.token = "";
    //   this.tokenType = "";
    //   this.refreshToken = "";
    //   this.userInfo = {};
    //   this.roles = [];
    //   this.permissions = [];
    // },
    // 获取用户详细信息，包括角色，权限
    // 用户信息取消使用持久化存储，仅使用共享存储
    async initUserInfo() {
      return new Promise<IResponse>(async (resolve, reject) => {
        try {
          const res = await getCurrentAdminUserInfo();
          if (res.code === 200) {
            this.userInfo = res.data || {};
            // if (this.userInfo && !this.userInfo?.telephone) await useRenderDialog({ modelValue: true });
            this.permissions = res.data.permissions || [];
            this.setPermissions(res.data.permissions);
            resolve(res);
          } else {
            reject(res);
          }
        } catch (error) {
          reject(error);
        }
      });
      // this.roles =
      //   res.data.roles.map((item: { disabled: any; role_key: any }) => {
      //     if (!item.disabled) {
      //       return item.role_key;
      //     }
      //   }) || [];
    }
  },
  persist: piniaPersistConfig("dev-user")
});
